module.exports = __webpack_public_path__ + "static/Footwear1-62af294feb34df25c7b903c658ded486.png";